export const mapSettingsDSL = (callback, settings) => {
    return settings.map(callback);
};
